import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/products/:cat",
    name: "products",
    component: () => import("../views/PageProducts.vue"),
    meta: {
      title: "All Products",
      name: "myProducts",
    },
  },
  {
    path: "/products/product-detils/:productId",
    name: "product-detils",
    component: () => import("../views/ProductDetils.vue"),
    meta: {
      title: "product detils",
      name: "product det",
    },
  },
  {
    path: "/cart-page",
    name: "cartPage",
    component: () => import("../views/cartPage.vue"),
  },
  {
    path: "/check-out",
    name: "checkOut",
    component: () => import("../views/CheckOut.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
